// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tWBxx","colMin":"styles_colMin__3gQyV"};